import { useMemoSelector } from '@spa/redux/hooks'

import { getPlanningPolicies } from './getPlanningPolicies'

export const usePlanningPolicies = () => {
  return useMemoSelector(getPlanningPolicies)
}
